import { Component, OnInit } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { TopArticles } from '../_model/topArticles';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  //changeDetection: ChangeDetectionStrategy.
})
export class LandingComponent implements OnInit {
  topArticles: TopArticles = {};
  loadingOverlay : boolean;
  constructor(private homeService: HomeService, private spinner: NgxSpinnerService) {
    this.getTopArticles();
    
  }

  ngOnInit() {
    this.loadingOverlay = false;
    this.homeService.landingLoad.subscribe(message => {
        this.loadingOverlay = message;
        console.log(this.loadingOverlay, "lading check");
        if(this.loadingOverlay == true){
          this.spinner.show();
        }else{
          this.spinner.hide();
        }
    });
  }

  getTopArticles() {
    this.homeService.getTopArticles().subscribe(res => {
      this.topArticles = res.return_body;
    });
  }


}
